import { Text } from '@chakra-ui/react';
import PublishTag from 'components/common/fields/PublishTag';
import { format, parseJSON } from 'date-fns';

export default [
  {
    name: 'Id',
    selector: (row) => row.id,
    sortable: true,
    width: '60px',
    sortField: 'id',
  },
  {
    name: 'Name',
    selector: (row) => row.name,
    sortable: true,
    cell: (row) => (
      <Text fontWeight={500} as="i">
        {row.name}
      </Text>
    ),
    sortField: 'name',
  },
  {
    name: 'Courses',
    selector: (row) => row.coursesCount,
    sortable: true,
    sortField: 'courses',
  },
  {
    name: 'Users',
    selector: (row) => row.usersCount,
    sortable: true,

    sortField: 'users',
  },
  {
    name: 'Description',
    selector: (row) => row.description,
    wrap: true,
    sortable: true,
    format: (row) => (
      <Text py={2}>
        {row.description.length > 150
          ? `${row.description.slice(0, 150)}...`
          : row.description}
      </Text>
    ),

    sortField: 'description',
  },

  {
    name: 'Start Date',
    selector: (row) => row.dateStart,
    cell: (row) => (
      <Text>{format(parseJSON(row.dateStart), 'MMMM d, yyyy')}</Text>
    ),
    sortable: true,
    sortField: 'dateStart',
  },

  {
    name: 'End Date',
    selector: (row) => row.dateEnd,
    cell: (row) => (
      <Text>{format(parseJSON(row.dateEnd), 'MMMM d, yyyy')}</Text>
    ),
    sortable: true,
    sortField: 'dateEnd',
  },
  {
    name: 'Status',
    selector: (row) => row.isPublished,
    sortable: true,
    cell: (row) => <PublishTag isPublished={row.isPublished} />,
    sortField: 'isPublished',
  },
];
